import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AiBrandKitSettings, AiCopySettings, AiMediaSettings, AiMessage, AiModelRef } from '../models';

export interface AiSendPayload {
  requestId: string;
  prompt: string;
  model?: AiModelRef;
  mode?: 'chat' | 'copy' | 'image' | 'image-edit' | 'video';
  context?: { key: string; value?: string }[];
  responseTypes?: string[];
  params?: { copy?: AiCopySettings, media?: AiMediaSettings, image?: AiMediaSettings, brand?: AiBrandKitSettings };
}

export interface AiAdapter {
  send(req: AiSendPayload): Observable<AiMessage | { chunk: string; requestId: string }>; // streaming-friendly
  cancel?(requestId: string): void;
  models?(): Observable<AiModelRef[]>;
}

export const AI_ADAPTER = new InjectionToken<AiAdapter>('AI_ADAPTER');
